/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiWebhookHeaderFromJSON(json) {
    return StreemApiWebhookHeaderFromJSONTyped(json, false);
}
export function StreemApiWebhookHeaderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'includeInRequestSignature': !exists(json, 'include_in_request_signature') ? undefined : json['include_in_request_signature'],
    };
}
export function StreemApiWebhookHeaderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': value.value,
        'include_in_request_signature': value.includeInRequestSignature,
    };
}
//# sourceMappingURL=StreemApiWebhookHeader.js.map